module.exports = __webpack_public_path__ + "img/img_policy_iso.b6d7fe9e.jpg";